export function formatAddress(address: Address) {
  if (!address) return ' ';
  if (address.isAdhoc) return address.address;
  return `${address.address} ${address.addressTwo || ''} ${address.city}, ${
    address.state
  } ${address.zip}`;
}
